<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMomMainProjectTemplateResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      import-enabled edit-disable with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button type="downloadFile"
                                                   custom-label="查看结构详情"
                                                   :busy="queryTreeLoading"
                                                   custom-icon="fa fa-solid fa-folder-tree"
                                                   class="btn btn-outline-primary btn-sm"
                                                   @click="viewTree(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <em-button type="delete"
                                               class="btn btn-outline-primary btn-sm"
                                               :busy="deleteLoading"
                                               :disabled="$_notChecked"
                                               @click="deleteAllByHead"
                                    ></em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <re-b-modal header="模板" ref="templateTree" fit-content no-ok-button
                    enable-popover no-close-on-backdrop>
            <mini-table ref="table"
                        :items="templateTree"
                        entity-name="sithMomMainProjectTemplate"
                        need-model-fields
                        enable-table-tree
                        tree-node-label-name="activityId"
                        tree-id-name="id"
                        tree-parent-id-name="parentId"
                        without-level
                        disable-first-index-column
                        read-only filterable
                        enable-tree-check
                        custom-columns="activate"
                        :default-expend-depth="1"
                        @rowChecked="checkedIds=$event">
                <template #leftHeader>
                    <mini-button :disable="checkedIds.length===0"
                                 :loading="changeStatusLoading"
                                 @btnClick="changeActivateStatus(true)">
                        <i class="fa-solid fa-check"></i>
                        启用
                    </mini-button>
                    <mini-button :disable="checkedIds.length===0"
                                 :loading="changeStatusLoading"
                                 @btnClick="changeActivateStatus(false)">
                        <i class="fa-solid fa-ban"></i>
                        禁用
                    </mini-button>
                </template>
                <template #custom(activate)="{row}">
                    <i v-if="row.activate" class="fa-solid fa-check" style="color: #50a34d"></i>
                    <i v-else class="fa-solid fa-ban" style="color: #ce4849"></i>
                </template>
            </mini-table>
        </re-b-modal>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2023-09-18 15:36:16

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMomMainProjectTemplateListView",
    components: {MiniButton, MiniTable, ReBModal},
    mixins: [emCommonListMixin, emCustomVuexMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            queryTreeLoading: false,
            templateTree: [],

            checkedIds: [],
            changeStatusLoading: false,
            selectedRow: null,

            deleteLoading: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        viewTree(row) {
            this.selectedRow = row;
            this.queryTreeLoading = true;
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectTemplate/query/byHead?headId=" + row.id
            }).then(response => {
                this.templateTree = response;
                this.$refs.templateTree.showModal();
            }).finally(() => this.queryTreeLoading = false);
        },
        changeActivateStatus(activate) {
            this.changeStatusLoading = true;
            let url = process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectTemplate/set/" + (activate ? 'activate' : 'deactivate');
            this.$store.dispatch('api/post', {
                url: url,
                data: this.checkedIds
            }).then(() => {
                this.$message.success("设置成功");
                this.viewTree(this.selectedRow);
            }).finally(() => this.changeStatusLoading = false);
        },

        deleteAllByHead() {
            if (this.$_checked) {
                this.deleteLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectTemplate/delete/byHead",
                    data: this.checkedItems
                }).then(() => {
                    this.$message.success("删除成功");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.deleteLoading = false);
            }
        },
    }
};
</script>
